import axios from "axios";
import * as actions from "./actionsType";
import messages from "../../messages";
import toastr from "toastr";
import PlanSeguimientoServices from "./PlanSeguimiento.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getPlanSeguimiento = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_PLAN_SEGUIMIENTO,
      payload: true,
    });
    debugger
    const resp = await PlanSeguimientoServices.getPlanSeguimiento(filters);
    dispatch({
      type: actions.GET_PLAN_SEGUIMIENTO,
      payload: {
        planSeguimiento: resp.data       
      },
    });
    dispatch({
      type: actions.PLAN_SEGUIMIENTO_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.PLAN_SEGUIMIENTO_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_PLAN_SEGUIMIENTO,
      payload: false,
    });
  }
};


export const savePlanSeguimiento =
  (data, filters) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_PLAN_SEGUIMIENTO,
        payload: true,
      });
      await PlanSeguimientoServices.savePlanSeguimiento(data);
      const resp = await PlanSeguimientoServices.getPlanSeguimiento(filters);
      dispatch({
        type: actions.GET_PLAN_SEGUIMIENTO,
        payload: {
          planSeguimiento: resp.data       
        },
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      toastr.success(messages.successMessage, " ", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 403:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADING_PLAN_SEGUIMIENTO,
        payload: false,
      });
    }
  };

export const editPlanSeguimiento =
  (dataPlanAccion, dataPlan, idPlanAccion, idPlan, filters) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_PLAN_SEGUIMIENTO,
        payload: true,
      });
      console.log("ver",dataPlan)
      await PlanSeguimientoServices.editPlanAccion(idPlanAccion, dataPlanAccion)
      await PlanSeguimientoServices.editPlan(idPlan, dataPlan)
      const resp = await PlanSeguimientoServices.getPlanSeguimiento(filters);
      dispatch({
        type: actions.GET_PLAN_SEGUIMIENTO,
        payload: {
          planSeguimiento: resp.data       
        },
      });
      
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });

      toastr.success(messages.successMessage, " ", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              const apiMessage = ex.response?.data?.mensaje;  // Accede al mensaje en la respuesta (para el caso en el que el plan ya tiene cursos asignados)
              message = messages.errorMessage;
      
              if (apiMessage) {
                message += ". " + apiMessage ;  // Agrega el mensaje de la API al mensaje de error
              }
              break;
            case 403:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_PLAN_SEGUIMIENTO,
        payload: false,
      });
    }
  };

export const deletePlanSeguimiento = (id, index) => async (dispatch, getState) => {
  try {
   
    dispatch({
      type: actions.LOADING_PLAN_SEGUIMIENTO,
      payload: true,
    });
    await PlanSeguimientoServices.deletePlan(id);
    const { planSeguimiento } = getState().planCarreraPlanSeguimiento;
    let _planSeguimiento = [...planSeguimiento]
    _planSeguimiento.splice(index, 1);
    dispatch({
      type: actions.GET_PLAN_SEGUIMIENTO,
      payload: {
        planSeguimiento: _planSeguimiento
      },
    });
    dispatch({
      type: actions.PLAN_SEGUIMIENTO_FAIL,
      payload: "",
    });

    toastr.success(messages.successMessage, " ", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 403:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;                         
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }

    dispatch({
      type: actions.PLAN_SEGUIMIENTO_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_PLAN_SEGUIMIENTO,
      payload: false,
    });
  }
};
